<div class="event-container">
  <!-- Month/Year Header -->
  <div class="header-container">
    <div class="month-header">
      <span>Events</span>
      <div class="widget-conta">
        <div class=" d-flex justify-content-between">
          <div (click)="currentView='list'" [matTooltipPosition]="'above'" [matTooltip]="'List'"
            [ngClass]="{'highlight': currentView==='list'}" class="cycleHover">
            <mat-icon class="listtoggleEventBtn" svgIcon="list"></mat-icon>
          </div>

          <div (click)="currentView='calendar'" [matTooltipPosition]="'above'" [matTooltip]="'Calender'"
            [ngClass]="{'highlight': currentView==='calendar'}" class="cycleHover">
            <mat-icon class="toggleEventBtn" svgIcon="notification_calendar"></mat-icon>
          </div>
        </div>
      </div>
      <div style="display: flex;gap: 10px;">
        <mat-icon class="du-mat-icons-event-header" [matTooltip]="sortAsc ? 'Asc' : 'Desc'" svgIcon="notes_sorting" (click)="eventSort()" ></mat-icon>
        <!-- <mat-icon class="du-mat-icons-event-header" svgIcon="notes_search"></mat-icon> -->
      </div>

    </div>
  </div>
  <div class="calender-header">
    <div class="calender-arrow" *ngIf="currentView === 'list'" routerLink="/direct/Calendar">
      <div> <mat-icon class="calendarIcon" svgIcon="notification_calendar"></mat-icon>
        &nbsp;{{'Full Calendar'}}</div>
      <mat-icon class="arrowIcon" svgIcon="right_arrow"></mat-icon>
    </div>

    <div class="date-picker" *ngIf="currentView === 'calendar'">
      <div class="navigation">
        
        <div class="days">
          <button *ngFor="let day of days" (click)="selectDate(day)"
            [class.selected]="selectedDate.isSame(day, 'day')">
            {{ day.format('DD') }}
          </button>
        </div>
      </div>
      
    </div>

  </div>

  <!-- List View -->
  <div class="list-view" *ngIf="currentView === 'list'">
    <loading *ngIf="isloading"></loading>
    <div style="height: 500px; width: auto; " *ngIf="object.keys(groupedEvents).length === 0 && !isloading">
      <span class="bg-text"> No Event </span>
    </div>
    <div class="day-section" *ngFor="let day of groupedEvents | keyvalue" >
      <div class="day-header">
        <div class="date-info">
          <span class="full-date">{{ formatDate(day.key) }}</span>
          <span class="day-name">{{ getDayName(day.key) }}</span>
        </div>
        <div style="border-bottom: 2px solid #D4D9E3;margin-top: 2px;height: 2px;width: calc(100% - 180px);"></div>
      </div>

      <div class="event-list">
        <!-- (click)="event.startTime ? selectDay(event) : null" -->
        <div class="event-item" *ngFor="let event of day.value" (click)="openEventDetails(event)"  [ngStyle]="{ 'background':event.type === 'Meeting' ? '#DF50971A' : '#e5f0f7', 'border': event.type === 'Meeting' ? '1px solid #DF5097' : '1px solid #0871B7' }">
          <div class="event-time" >
            <svg *ngIf="event.type != 'Meeting'" width="20" height="20" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 0.945455C8.03345 0.945455 11.3338 0.945454 13.5127 1.10255L13.6087 1.11127C13.8996 1.13745 14.2138 1.168 14.5222 1.48655C14.6676 1.632 14.8335 2.14691 14.8902 2.51491C14.9821 3.3219 15.0307 4.13325 15.0356 4.94546V6.144C15.0305 6.95668 14.982 7.7685 14.8902 8.576C14.8364 8.93527 14.6662 9.45745 14.5236 9.59418C14.2167 9.91127 13.8953 9.94182 13.6116 9.96946L13.5127 9.97964C11.3716 10.1251 8.14691 10.1396 8.00145 10.1396C7.83418 10.1396 3.92873 10.1004 2.68218 9.99418C2.608 9.98255 2.53673 9.97236 2.45236 9.96364C2.12073 9.92436 1.744 9.87927 1.47345 9.59855C1.328 9.45309 1.16218 8.93964 1.10691 8.57309C1.01496 7.7661 0.966404 6.95475 0.961454 6.14255V4.95564C0.966624 4.14344 1.01518 3.3321 1.10691 2.52509C1.16364 2.15418 1.33236 1.63927 1.47491 1.49673C1.78327 1.17818 2.10473 1.14909 2.38836 1.12145L2.48436 1.11273C4.66618 0.957091 7.96364 0.955636 7.99564 0.955636H8V0.945455ZM8 0.0101818C8 0.0101818 4.64145 0.0101815 2.40291 0.170182C2.09018 0.206545 1.40945 0.209454 0.802909 0.837818C0.324364 1.31782 0.167273 2.40727 0.167273 2.40727C0.0655609 3.25309 0.00972163 4.10379 0 4.95564V6.15418C0.00692232 7.0093 0.0603345 7.86341 0.16 8.71273C0.16 8.71273 0.315636 9.80218 0.795636 10.2807C1.40509 10.9091 2.20364 10.8902 2.56 10.9571C3.84 11.0778 8 11.1156 8 11.1156C8 11.1156 11.3615 11.1156 13.6015 10.9513C13.9142 10.9149 14.5964 10.9105 15.2015 10.2822C15.68 9.80364 15.8371 8.71418 15.8371 8.71418C15.9377 7.86491 15.9921 7.01081 16 6.15564V4.95709C15.9931 4.10197 15.9396 3.24787 15.84 2.39855C15.84 2.39855 15.6844 1.30909 15.2044 0.829091C14.5964 0.200727 13.9142 0.196363 13.6044 0.161454C11.3615 -1.90735e-07 8 0 8 0V0.0101818Z" fill="#0871B7"/>
              <path d="M6.56436 3.17188V7.93987L10.6356 5.55587L6.56436 3.17188Z" fill="#0871B7"/>
              </svg>
              <svg *ngIf="event.type === 'Meeting'" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_29894_2514)">
                <path d="M12.5304 2.0011H11.0305V1.5011C11.0305 1.22498 10.8067 1.0011 10.5306 1.0011H9.44516C9.16953 0.219976 8.31271 -0.189815 7.53159 0.0859423C7.10385 0.236943 6.7673 0.573369 6.6163 1.0011H5.53098C5.25485 1.0011 5.03098 1.22498 5.03098 1.5011V2.0011H3.5311C2.70273 2.0011 2.03122 2.67261 2.03122 3.50098V14.5001C2.03122 15.3285 2.70273 16 3.5311 16H12.5305C13.3589 16 14.0304 15.3285 14.0304 14.5001V3.50098C14.0302 2.67261 13.3587 2.0011 12.5304 2.0011ZM6.03085 2.0011H7.03085C7.30698 2.0011 7.53085 1.77723 7.53085 1.5011C7.53085 1.22498 7.75461 1.0011 8.03073 1.0011C8.30686 1.0011 8.53073 1.22498 8.53073 1.5011C8.53073 1.77723 8.75461 2.0011 9.03073 2.0011H10.0306V3.00098H6.03085V2.0011ZM13.0304 14.5001C13.0304 14.7763 12.8065 15.0001 12.5304 15.0001H3.5311C3.25497 15.0001 3.0311 14.7763 3.0311 14.5001V3.50098C3.0311 3.22486 3.25497 3.00098 3.5311 3.00098H5.03098V3.50098C5.03098 3.77711 5.25485 4.00086 5.53098 4.00086H10.5306C10.8067 4.00086 11.0305 3.77711 11.0305 3.50098V3.00098H12.5305C12.8066 3.00098 13.0304 3.22486 13.0304 3.50098V14.5001Z" fill="#DF5097"/>
                <path d="M11.0305 6H5.03101C4.75488 6 4.53101 6.22388 4.53101 6.5C4.53101 6.77613 4.75488 7.00001 5.03101 7.00001H11.0305C11.3067 7.00001 11.5305 6.77613 11.5305 6.5C11.5305 6.22388 11.3067 6 11.0305 6Z" fill="#DF5097"/>
                <path d="M11.0305 9H5.03101C4.75488 9 4.53101 9.22388 4.53101 9.5C4.53101 9.77613 4.75488 10 5.03101 10H11.0305C11.3067 10 11.5305 9.77613 11.5305 9.5C11.5305 9.22388 11.3067 9 11.0305 9Z" fill="#DF5097"/>
                <path d="M11.0305 12H5.03101C4.75488 12 4.53101 12.2238 4.53101 12.4999C4.53101 12.776 4.75488 12.9999 5.03101 12.9999H11.0305C11.3067 12.9999 11.5305 12.776 11.5305 12.4999C11.5305 12.2238 11.3067 12 11.0305 12Z" fill="#DF5097"/>
                </g>
                <defs>
                <clipPath id="clip0_29894_2514">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
                </svg>
                
                
              
          </div>
          <div class="event-details">
            <h3 class="event-title">{{ event.event_name }}</h3>
            <div>
             <span class="time-range">{{ event.start_time }} - {{ event.end_time }}</span>
             <span style="color: #fff;">&nbsp;&nbsp;|&nbsp;&nbsp;</span> 
             <span class="event-type">{{ event.type }}</span>
           </div> 
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Calendar View -->
  <div  *ngIf="currentView === 'calendar'">
    <div style="display: flex;justify-content: space-around;width: 100%;align-items: center;height: 56px;"> 
      <span (click)="prevDate()">
      <svg width="35" height="35"  viewBox="14 7 35 35" fill="none" >
        <g >
        <rect x="47.5" y="39.5" width="31" height="31" rx="7.5" transform="rotate(180 47.5 39.5)" stroke="#E8EAEE"/>
        </g>
        <path d="M30.8466 25.04L37 25.04L37 22.96L30.8466 22.96L33.2376 20.4772L31.815 19L27 24L31.815 29L33.2376 27.5228L30.8466 25.04Z" fill="#1363DF"/>
        
        </svg> </span>
      <div class="date-display">{{ formattedDate }}</div> 
      <span (click)="nextDate()"> 
     <svg  width="35" height="35" viewBox="14 7 35 35" fill="none" >
        <g >
        <rect x="16.5" y="8.5" width="31" height="31" rx="7.5" stroke="#E8EAEE"/>
        </g>
        <path d="M33.1534 22.96L27 22.96L27 25.04L33.1534 25.04L30.7624 27.5228L32.185 29L37 24L32.185 19L30.7624 20.4772L33.1534 22.96Z" fill="#1363DF"/>
       
        </svg>
      </span>
    </div>
  
  <!-- <div class="timeline">
    <div *ngFor="let time of timeSlots" class="time-slot">
      <div class="label">{{ time }}</div>
      <div class="events">
        <ng-container *ngFor="let event of getEventsAtTime(time)">
          <div class="event-card" [style.top.%]="getTopOffset(event)" [style.height.%]="getEventHeight(event)">
            <strong>{{ event.event_name }}</strong><br />
            {{ event.start_time }} - {{ event.end_time }}<br />
            <small>{{ event.type }}</small>
          </div>
        </ng-container>
      </div>
    </div>
  </div> -->
  <div class="main-container">

    <div class="calendar-container">
      <div class="timeline">
        <div *ngFor="let time of generateTimeSlots()" class="time-slot">
          <div class="label">{{ time }}</div>
        </div>
      </div>
    
      <div class="events-layer">
        <ng-container *ngFor="let group of getGroupedEvents()">
          <ng-container *ngFor="let event of group; let i = index">
            <div
              class="event-card"
              [style.top.px]="getTopOffset(event.start_time)"
              [style.height.px]="getEventHeight(event.start_time, event.end_time)"
              [style.left.%]="i * (100 / group.length)"
              [style.width.%]="100 / group.length"
              (click)="openEventDetails(event)"
            >
              <div><strong>{{ event.event_name }}</strong></div>
              <div>{{ event.start_time }} - {{ event.end_time }}</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  
  </div>


</div>

<div class="du-event-icon-bottom"  on (click)="addEvent()" matTooltip="Create Event" matTooltipPosition="above">
  <svg width="73" height="69" viewBox="0 0 73 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_29894_2562)">
      <rect x="25" y="21" width="36" height="36" rx="18" fill="#1363DF" />
      <rect x="25" y="21" width="36" height="36" rx="18" fill="url(#paint0_linear_29894_2562)" fill-opacity="0.3"
        style="mix-blend-mode:overlay" />
    </g>
    <g clip-path="url(#clip0_29894_2562)">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M40.5802 32C40.9561 32 41.2608 32.3169 41.2608 32.7079V33.2584H44.7392V32.7079C44.7392 32.3169 45.0439 32 45.4198 32C45.7956 32 46.1003 32.3169 46.1003 32.7079V33.2601C46.358 33.2627 46.5868 33.2694 46.7881 33.2865C47.1328 33.3158 47.4565 33.3791 47.7625 33.5413C48.232 33.7902 48.6138 34.1872 48.853 34.6756C49.009 34.9939 49.0699 35.3305 49.098 35.6891C49.125 36.0328 49.125 36.4536 49.125 36.9578V42.3007C49.125 42.8048 49.125 43.2256 49.098 43.5694C49.0699 43.9279 49.009 44.2645 48.853 44.5828C48.6138 45.0712 48.232 45.4683 47.7625 45.7171C47.4565 45.8793 47.1328 45.9426 46.7881 45.9719C46.4576 46 46.0531 46 45.5684 46H40.4316C39.9469 46 39.5424 46 39.2119 45.9719C38.8672 45.9426 38.5435 45.8793 38.2375 45.7171C37.768 45.4683 37.3862 45.0712 37.147 44.5828C36.991 44.2645 36.9302 43.9279 36.902 43.5694C36.875 43.2256 36.875 42.8048 36.875 42.3006V36.9578C36.875 36.4536 36.875 36.0328 36.902 35.6891C36.9302 35.3305 36.991 34.9939 37.147 34.6756C37.3862 34.1872 37.768 33.7902 38.2375 33.5413C38.5435 33.3791 38.8672 33.3158 39.2119 33.2865C39.4132 33.2694 39.642 33.2627 39.8997 33.2601V32.7079C39.8997 32.3169 40.2044 32 40.5802 32ZM39.8997 34.6759C39.6671 34.6784 39.481 34.6841 39.3227 34.6975C39.0622 34.7197 38.9376 34.7592 38.8554 34.8027C38.642 34.9159 38.4685 35.0963 38.3597 35.3183C38.3179 35.4038 38.2799 35.5334 38.2586 35.8044C38.2366 36.0836 38.2361 36.4462 38.2361 36.9865V37.0337H47.7639V36.9865C47.7639 36.4462 47.7634 36.0836 47.7414 35.8044C47.7201 35.5334 47.6821 35.4038 47.6403 35.3183C47.5315 35.0963 47.358 34.9159 47.1446 34.8027C47.0624 34.7592 46.9378 34.7197 46.6773 34.6975C46.519 34.6841 46.3329 34.6784 46.1003 34.6759V35.2247C46.1003 35.6157 45.7956 35.9326 45.4198 35.9326C45.0439 35.9326 44.7392 35.6157 44.7392 35.2247V34.6742H41.2608V35.2247C41.2608 35.6157 40.9561 35.9326 40.5802 35.9326C40.2044 35.9326 39.8997 35.6157 39.8997 35.2247V34.6759ZM47.7639 38.4494H38.2361V42.2719C38.2361 42.8122 38.2366 43.1748 38.2586 43.4541C38.2799 43.7251 38.3179 43.8546 38.3597 43.9401C38.4685 44.1621 38.642 44.3426 38.8554 44.4557C38.9376 44.4992 39.0622 44.5388 39.3227 44.5609C39.5912 44.5837 39.9398 44.5843 40.4593 44.5843H45.5407C46.0602 44.5843 46.4088 44.5837 46.6773 44.5609C46.9378 44.5388 47.0624 44.4992 47.1446 44.4557C47.358 44.3426 47.5315 44.1621 47.6403 43.9401C47.6821 43.8546 47.7201 43.7251 47.7414 43.4541C47.7634 43.1748 47.7639 42.8122 47.7639 42.2719V38.4494Z"
        fill="white" />
    </g>
    <mask id="path-3-outside-1_29894_2562" maskUnits="userSpaceOnUse" x="33" y="40" width="7" height="7" fill="black">
      <rect fill="white" x="33" y="40" width="7" height="7" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36 44L36 46H37V44H39V43H37V41H36L36 43H34V44H36Z" />
    </mask>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M36 44L36 46H37V44H39V43H37V41H36L36 43H34V44H36Z" fill="white" />
    <path
      d="M36 46H35C35 46.5523 35.4477 47 36 47V46ZM36 44H37C37 43.4477 36.5523 43 36 43V44ZM37 46V47C37.5523 47 38 46.5523 38 46H37ZM37 44V43C36.4477 43 36 43.4477 36 44H37ZM39 44V45C39.5523 45 40 44.5523 40 44H39ZM39 43H40C40 42.4477 39.5523 42 39 42V43ZM37 43H36C36 43.5523 36.4477 44 37 44V43ZM37 41H38C38 40.4477 37.5523 40 37 40V41ZM36 41V40C35.7348 40 35.4804 40.1054 35.2929 40.2929C35.1054 40.4804 35 40.7348 35 41L36 41ZM36 43V44C36.2652 44 36.5196 43.8946 36.7071 43.7071C36.8946 43.5196 37 43.2652 37 43H36ZM34 43V42C33.4477 42 33 42.4477 33 43H34ZM34 44H33C33 44.5523 33.4477 45 34 45V44ZM37 46L37 44H35L35 46H37ZM37 45H36V47H37V45ZM36 44V46H38V44H36ZM39 43H37V45H39V43ZM38 43V44H40V43H38ZM37 44H39V42H37V44ZM36 41V43H38V41H36ZM36 42H37V40H36V42ZM37 43V41L35 41L35 43H37ZM34 44H36V42H34V44ZM35 44V43H33V44H35ZM36 43H34V45H36V43Z"
      fill="#1363DF" mask="url(#path-3-outside-1_29894_2562)" />
    <defs>
      <filter id="filter0_d_29894_2562" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="12.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0745098 0 0 0 0 0.388235 0 0 0 0 0.87451 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29894_2562" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_29894_2562" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_29894_2562" x1="25" y1="21" x2="67.1643" y2="30.9945"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_29894_2562">
        <rect width="14" height="14" fill="white" transform="translate(36 32)" />
      </clipPath>
    </defs>
  </svg>
</div>